// courtesy of css-tricks.com/single-element-loaders-the-spinner

/**
 * Renders loading spinner whilst data is loaded
 * @function Loader
 * @returns {JSX}
 */
const Loader = () => {
  return (
    <span className="loader"></span>
  )
}

export default Loader;